import React from 'react';
import PropTypes from 'prop-types';
import { notificationsReducer, INITIAL_STATE } from './notificationsReducer';

export const NotificationsStore = React.createContext();

export const NotificationsStoreProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(notificationsReducer, INITIAL_STATE);
  const value = { state, dispatch };
  return <NotificationsStore.Provider value={value}>{children}</NotificationsStore.Provider>;
};

NotificationsStoreProvider.propTypes = {
  children: PropTypes.node,
};
